@if (configLoaded && taxReturn) {
<app-notes [assignee]="taxReturn.assignee" [taxReturn]="taxReturn"></app-notes>
}
